// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "." + "f454586b3133fb5c2241" + ".chunk.css";
};